<template>
    <v-layout align-center class="pb-3">
      <v-flex xs8 py-1 pl-4>
        <v-select
        :items="invoices"
        :label='invoiceMatchText'
        hide-details
        item-value="id"
        v-model="selectedInvoiceId"
        dense
        >
        <template v-slot:selection="data">
        <!-- HTML that describe how select should render selected items -->
          <span>{{ data.item.invoice_ref }} for {{ data.item.clientName }} - <strong>{{ data.item.amount| toCurrency(lang, currCode) }}</strong></span>
        </template>
        <template v-slot:item="data">
          <!-- HTML that describe how select should render items when the select is open -->
          <span >{{ data.item.invoice_ref }} for {{ data.item.clientName }} - <strong>{{ data.item.amount| toCurrency(lang, currCode) }}</strong></span>
        </template>
        </v-select>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex shrink >
        <v-btn color="accent" small depressed @click="matchInvoice" class="tinybut  white--text text-none" :disabled="!selectedInvoiceId">Mark as paid</v-btn>
      </v-flex>
    </v-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  props: {
    transaction: {
      type: Object
    }
  },
  data () {
    return {
      user: this.$store.getters.user,
      invoices: [],
      selectedInvoiceId: '',
      alertThreshold: this.$store.getters.group.chosenAlertTimeScale,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      assigned: false
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    invoiceMatchText () {
      if ((this.invoices.length === 1) && (this.isMatchingMode)) {
        return `We've matched ${this.invoices.length} invoice:`
      }
      if ((this.invoices.length > 1) && (this.isMatchingMode)) {
        return `We've matched ${this.invoices.length} invoices:`
      }
      return 'Select an invoice to match this transaction to:'
    },
    isMatchingMode () {
      return this.transaction.matchedInvoices
    }
  },
  mixins: [formatDate],
  methods: {
    async matchInvoice () {
      // start loader
      this.$store.commit('setLoading', true)
      try {
        const transactionDate = new Date(this.transaction.date)
        const invoiceUpdate = {
          id: this.selectedInvoiceId,
          status: 'Paid',
          paid_date: transactionDate.toISOString()
        }
        // update the invoice
        await this.$store.dispatch('updateInvoice', invoiceUpdate)
        // build the activity Msg
        const activityMsg = {
          status: 'Marked as paid',
          by: this.user.email,
          created: this.formatDateToISO(Date.now())
        }
        // Save the activity Msg to the invoice timeline
        await firebase.database().ref('invoices-activity/' + this.user.group + '/' + this.selectedInvoiceId).push(activityMsg)
        // get the listId of the Job
        const JobListId = this.$store.getters.getListIdFromJobId(this.selectedInvoiceId)
        // update the job paid_date
        await firebase.database().ref(`lists/${this.user.group}/list${JobListId}/${this.selectedInvoiceId}`).update({
          paid_date: transactionDate.toISOString()
        })
        // setup the notification text
        let activityText = 'Invoice marked as Paid'
        // if we are not in the invoice column lets move the job there as it's now marked as sent
        if (JobListId !== 5) {
          await this.$store.dispatch('moveJob', { jobId: this.selectedInvoiceId, oldList: JobListId, newList: 5 })
          // amend the notification text to say that the job moved columns
          activityText = 'Invoice marked as Paid and moved to the Paid column.'
        }
        // all is well so stop the loader..
        this.$store.commit('setLoading', false)
        // and dispatch the notification
        this.$store.dispatch('addNotification', { text: activityText, type: 'primary' })
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    },
    fetchSentInvoices () {
      firebase.database().ref(`/invoices/${this.user.group}/`).orderByChild('status').equalTo('Sent').once('value')
        .then(data => {
          this.$store.commit('setLoading', false)
          const obj = data.val()
          for (let key in obj) {
            this.invoices.push(obj[key])
          }
        })
        .catch(
          (error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        )
    }
  },
  created () {
    // if we are showing this as part of the matched invoices bit then use the already present matched invoice array
    if (this.transaction.matchedInvoices) {
      this.invoices = this.transaction.matchedInvoices
      // preselect the first invoice in the list
      this.selectedInvoiceId = this.invoices[0].id
    } else {
      // else get all sent invoices
      this.fetchSentInvoices()
    }
  }
}
</script>
